/**
 * TypingIndicator Component
 *
 * Animated indicator showing the AI is typing.
 * Phase 7: Frontend Integration
 *
 * @module TypingIndicator
 */

'use client';

import { Flex, Text } from '@axon/ui';
import { useTranslations } from 'next-intl';
import { LuBot } from 'react-icons/lu';

import { AnimatedDots } from '@/components/shared/AnimatedDots';

// ============================================================================
// Component
// ============================================================================

/**
 * TypingIndicator component
 *
 * Shows animated dots when AI is processing/typing.
 *
 * @example
 * {isTyping && <TypingIndicator />}
 */
export function TypingIndicator() {
  const t = useTranslations('chatbot');

  return (
    <Flex
      paddingX="4"
      paddingY="2"
      align="center"
      gap="2"
      borderTop="1px solid"
      borderColor="border.default"
      bg="bg.subtle"
      flexShrink={0}
    >
      {/* Bot icon */}
      <Flex
        width="6"
        height="6"
        borderRadius="full"
        colorPalette="blue"
        bg="colorPalette.subtle"
        color="colorPalette.fg"
        align="center"
        justify="center"
      >
        <LuBot size={12} />
      </Flex>

      {/* Typing text */}
      <Text fontSize="xs" color="fg.muted">
        {t('isTyping')}
      </Text>

      {/* Animated dots */}
      <AnimatedDots />
    </Flex>
  );
}

export default TypingIndicator;
